import React from 'react'
import { ArrowPathIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Button } from './ui/button'

interface UpdateAvailableBannerProps {
  visible: boolean
  deployedVersion: string | null
  onReload: () => void
  onDismiss: () => void
}

const UpdateAvailableBanner: React.FC<UpdateAvailableBannerProps> = ({
  visible,
  deployedVersion,
  onReload,
  onDismiss,
}) => {
  if (!visible || !deployedVersion) return null

  return (
    <div
      role="alert"
      className="fixed bottom-0 left-0 right-0 z-50 border-t-4 border-amber-400 bg-amber-50 px-4 py-4 shadow-2xl ring-1 ring-amber-200/80 dark:border-amber-500 dark:bg-gray-900 dark:ring-amber-500/40"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <ExclamationTriangleIcon
            className="mt-0.5 h-6 w-6 shrink-0 text-amber-500 dark:text-amber-400"
            aria-hidden
          />
          <div className="min-w-0">
            <p className="text-sm font-semibold text-amber-950 dark:text-amber-100">
              Nova versão disponível (v{deployedVersion})
            </p>
            <p className="mt-0.5 text-sm text-amber-900/90 dark:text-amber-200/90">
              Atualize o site para ver as funcionalidades mais recentes.
            </p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2 sm:pl-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => {
              void onDismiss()
            }}
            className="border-amber-300 bg-white text-amber-950 hover:bg-amber-100 dark:border-amber-600 dark:bg-gray-800 dark:text-amber-100 dark:hover:bg-gray-700"
          >
            Depois
          </Button>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => {
              void onReload()
            }}
            className="inline-flex items-center gap-1.5 bg-primary-600 text-white shadow-sm ring-1 ring-primary-600 hover:bg-primary-700 dark:bg-primary-500 dark:text-white dark:ring-primary-500 dark:hover:bg-primary-600"
          >
            <ArrowPathIcon className="h-4 w-4" />
            Atualizar agora
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UpdateAvailableBanner
